import { reorder } from "@atlaskit/pragmatic-drag-and-drop/reorder";

export const getColumnOrderReorderResult = (
  sourceId: string,
  targetId: string,
  currentOrder: string[],
): string[] | null => {
  if (sourceId === targetId) return null;

  const startIndex = currentOrder.indexOf(sourceId);
  const finishIndex = currentOrder.indexOf(targetId);

  if (startIndex === -1 || finishIndex === -1) return null;

  return reorder({ list: currentOrder, startIndex, finishIndex });
};
